import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/common.css';
import accountLogo from '../assests/accountLogo.png'
import juiceai from '../assests/juiceai.png'
import pdp from '../assests/PDP.png'
import Line from '../assests/Line.png'
import { GoSignOut } from "react-icons/go";
import { useDispatch } from 'react-redux';
import {logoutUser} from '../util/slices/user';
import { getAuth } from 'firebase/auth';

const Header = ({ showAvatar = true }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const auth = getAuth();
  const user = auth.currentUser;

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };
  
  const handleLogOut = async () => {
    try {
      setIsMenuOpen(false); 
      const result = await dispatch(logoutUser());
      console.log("Logout result:", result);
      
      if (logoutUser.fulfilled.match(result)) {
        
        navigate('/');
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  }

  return (
    <header className="login-header">
      <div className="logo-text" onClick={() => navigate('/home')} style={{ cursor: 'pointer' }}>
        <img src={juiceai} alt="Juice AI" style={{ height: "36px" }} />
        <div className="pdp-text">
          <img src={Line} alt="|" style={{ margin: "0 5px" }} />
          <img src={pdp} alt="PDP" />
        </div>
      </div>

      <div className='header-profile'>
        {showAvatar && (
          <div className="header-avatar" onClick={toggleMenu}>
            <img src={accountLogo} alt="Account" />
          </div>
        )}

        {isMenuOpen && (
          <div className="profile-dropdown-menu">
            <div className="profile-dropdown-header">
              <span className="profile-dropdown-email">{user?.email }</span>
            </div>

            <hr className="profile-dropdown-divider" />

            <div
              className="profile-dropdown-item"
              onClick={handleLogOut}
            >
              <GoSignOut /> <span>Sign Out</span>
            </div>
          </div>
        )}

      </div>

    </header>
  );
};

export default Header;
